import * as React from "react";
import { Text, View, Image, TouchableOpacity, StyleSheet } from "react-native";

import { useNavigation } from "@react-navigation/native";
import GlobalStyles from "../../components/GlobalStyles";
import { Ionicons } from "@expo/vector-icons";
// import UnderLine from "../../components/AnimatedUnderLine";
import { ScrollView } from "react-native-gesture-handler";
import { Auth } from "aws-amplify";
import getEnvVars from "../../enviroment";
import GenericButton from "../../components/GenericButton.js";
import Colors from "../../utilities/Color.js";
import { checkLastLoginAndRoute } from "../../redux/actions/UserActions";

const awsConfig = getEnvVars().awsConfig;

Auth.configure(awsConfig);

export default function SignUpModeChoiceScreen() {
  const navigation = useNavigation();
  const MenuLogo = require("../../assets/res/Aura_Alpha_Reversed_BlueBG.gif");
  return (
    <View style={GlobalStyles.containerMB}>
      <ScrollView>
        <View style={GlobalStyles.bodyContainerCards}>
          <View style={styles.container}>
            <View style={styles.containerA}>
              <Image
                style={styles.tinyLogo}
                source={MenuLogo}
                resizeMode="contain"
              />
            </View>
            <OptionButton
              icon="ios-phone-portrait"
              label="Register with Phone"
              onPress={() => navigation.navigate("SignUp", { formMode: "p" })}
              subtext="Full name here"
            />
            <OptionButton
              icon="ios-mail"
              label="Register with Email"
              onPress={() => navigation.navigate("SignUp", { formMode: "e" })}
              subtext="Full name here"
            />
            {/* <OptionButton
              icon="logo-apple"
              label="Continue with Apple"
              subtext="Full name here"
              onPress={() => Auth.federatedSignIn({provider: 'SignInWithApple'})} 
            />

            <OptionButton
              icon="logo-google"
              label="Continue with Google"
              subtext="Full name here"
             onPress={() => Auth.federatedSignIn({provider: 'Google'})}
            /> */}

            <Text style={styles.TextStylePrompt}>ALREADY A MEMBER?</Text>
             {/* This commented part can be removed in 24/10/23  */}
            {/* <TouchableOpacity
              style={styles.linkStyle}
              activeOpacity={0.5}
              onPress={() => navigation.navigate("LoginModeChoice")}
            >
              <Text style={styles.TextStyleLink}>LOG IN</Text>
              <UnderLine />
            </TouchableOpacity> */}
            <GenericButton
                buttonText='LOG IN'
                // onPress={() => navigation.navigate("LoginModeChoice")}
                onPress={() => checkLastLoginAndRoute(navigation) }
              />
          </View>
        </View>
      </ScrollView>
    </View>
  );
}

function OptionButton({ icon, label, onPress, subtext, isLastOption }) {
  return (
    <TouchableOpacity
      style={styles.containerBox}
      activeOpacity={0.7}
      onPress={onPress}
    >
      <View style={styles.SubmitButtonStyle}>
        <View style={styles.optionIconContainer}>
          <Ionicons name={icon} size={24} color="rgba(0,0,0,0.99)" />
        </View>
        <View style={styles.optionTextContainer}>
          <Text style={styles.optionText}>{label}</Text>
        </View>
        <View style={styles.optionIconContainer}></View>
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  buttonStyle: {
    marginTop: 10,
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#337599",
    borderRadius: 30,
  },
  container: {
    paddingTop: 20,
    marginLeft: 30,
    marginRight: 30,
  },
  containerA: {
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 20,
    paddingBottom: 50,
  },
  tinyLogo: {
    height: 70,
    width: 120,
  },
  optionIconContainer: {
    flex: 1,
    alignItems: "center",
  },
  optionTextContainer: {
    flex: 8,
    alignSelf: "center",
  },
  optionText: {
    color: "#506685",
    fontFamily: "montserrat-bold",
    fontSize: 15,
    textAlign: "center",
  },
  containerBox: {

    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    paddingTop: 15,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 15,
    marginBottom: 20,
    width: 350,
    alignSelf:"center",
  },
  SubmitButtonStyle: {
    flexDirection: "row",
  },
  TextStyleLink: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    paddingTop: 10,
  },
  TextStylePrompt: {
    color: Colors.WHITE,
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 12,
    paddingTop: 50,
    paddingBottom: 10,
  },
});
